import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CompteComponent } from './compte.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ComponentsModule } from '../../components/components.module';


@NgModule({
  declarations: [CompteComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    RouterModule.forChild([{path: '', component: CompteComponent}]),
    ReactiveFormsModule,
    ComponentsModule
  ]
})
export class CompteModule {
}
